import { useEffect, useState } from "react";
import Input from "../../designComponents/Input";
import Button from "../../designComponents/Button";
import requestAPI from "../../utils/requestAPI";
import scrape from "../../apiConfigs/scrape";
import { toast } from "react-toastify";
import { DetailsWrapperStyled, InfoRowStyled } from "../Properties/Details";
import Typography from "../../designComponents/Typography";
import Select from "../../designComponents/Select";
import users from "../../apiConfigs/users";
import { UserTypes } from "../Users";
import { useNavigate } from "react-router-dom";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  Title,
  TitleSection,
  ValueText,
  Wrapper,
} from "../Properties/Details/styles";
import Dropdown from "../../designComponents/Dropdown/Dropdown";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";

type UrlType = {
  area: string;
  bathrooms: string;
  bedrooms: string;
  ber: string;
  description: string;
  price: string;
  title: string;
  _id: string;
};

const Scraped = () => {
  const navigate = useNavigate();
  const [url, setUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [apiError, setApiError] = useState<string>();
  const [scrapedData, setScrapedData] = useState<UrlType>();
  const [landlordData, setLandlordData] = useState<UserTypes[]>([]);
  const [selectedLandlord, setSelectedLandlord] = useState<string | number>("");
  const [search, setSearch] = useState<string | "">("");
  const handleScrape = async () => {
    const trimmedUrl = url.trim();

    if (!trimmedUrl) {
      setErrorMessage("Please enter a valid URL.");
      return;
    }

    if (!selectedLandlord) {
      setErrorMessage("Please select a landlord.");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      const response = await requestAPI(
        scrape.getScrape(url, selectedLandlord)
      );
      setScrapedData(response);
      setIsLoading(false);
      toast.success("Data scraped successfully!");
    } catch (e: any) {
      setApiError(e.message);
      setIsLoading(false);
    }
  };

  const getAllLandlord = async (role: string) => {
    try {
      const response = await requestAPI(
        users.getUsers({ roles: "LANDLORD", limit: 100000, search: search })
      );
      setLandlordData(response.data);
      console.log(landlordData);
    } catch (error) {
      console.log(error, "error fetching users");
    }
  };

  useEffect(() => {
    getAllLandlord("LANDLORD");
  }, [search]);
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      setErrorMessage("");
    }
  }, [errorMessage]);

  useEffect(() => {
    if (apiError) {
      toast.error(apiError);
      setApiError("");
    }
  }, [apiError]);
  return (
    <Wrapper style={{ paddingTop: 30 }}>
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Title>Scrape Property</Title>

          <div>
            <LabelInputField
              placeHolder="Provide a valid URL"
              label="Enter URL to Scrape"
              name="search"
              style={{
                label: {
                  fontSize: "14px",
                  fontWeight: "500px",
                  color: "#555A77",
                },
                input: {
                  height: 50,
                  border: "1px solid #F1EFFB",
                  padding: 8,
                  borderRadius: 6,
                  width: "100%",
                },
                container: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                  paddingTop: 14,
                },
              }}
              onChange={(e) => {
                setUrl(e.target.value);
              }}
            ></LabelInputField>
          </div>

          <div style={{ width: "400px" }}>
            <Dropdown
              setSearch={setSearch}
              enableSearch={true}
              placeHolder="Select a landlord"
              onSearch={(e) => {
                setSearch(e.target.value);
              }}
              options={
                landlordData
                  ? landlordData?.map((landlord) => ({
                      label: landlord?.firstName + " " + landlord?.lastName,
                      value: landlord?._id,
                    }))
                  : []
              }
              onSelect={(e) => setSelectedLandlord(e)}
              label="Select a Landlord"
            ></Dropdown>
          </div>
        </div>

        <AcceptButton
          radius="md"
          style={{ marginTop: "20px" }}
          isLoading={isLoading}
          onClick={handleScrape}
        >
          Scrape property
        </AcceptButton>
      </div>

      {scrapedData && (
        <Card style={{ margin: "0px" }}>
          <TitleSection
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <SectionTitle>Property Details</SectionTitle>

            <AcceptButton
              onClick={() => navigate(`/properties/${scrapedData?._id}`)}
            >
              View Property
            </AcceptButton>
          </TitleSection>
          <ButtonsSection>
            <LabelText>Address</LabelText>
            <ValueText>{scrapedData.title}</ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Area</LabelText>
            <Typography style={{ color: "gray" }}>
              {scrapedData.area}
            </Typography>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Bedrooms</LabelText>
            <ValueText>{scrapedData.bedrooms}</ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Bathrooms</LabelText>
            <ValueText>{scrapedData.bathrooms}</ValueText>
          </ButtonsSection>
          <ButtonsSection style={{ gap: 100 }}>
            <LabelText>Description</LabelText>
            <ValueText>{scrapedData.description}</ValueText>
          </ButtonsSection>
        </Card>
      )}
    </Wrapper>
  );
};

export default Scraped;
